import { useBenefitsInteractor } from '../interactor/useBenefitsInteractor';
import { BenefitsView } from '../view/BenefitsView';

/**
 * Presenter (Controller) for Benefits Section
 * Connects the Interactor (business logic) with the View (UI)
 */
export const BenefitsPresenter = () => {
  const { benefits } = useBenefitsInteractor();

  return <BenefitsView benefits={benefits} />;
};

export default BenefitsPresenter;
